<script>
  // core components
  import VendedorView from "../../viewsERP/Vendedor.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <VendedorView />
  </div>
</div>